import { render, staticRenderFns } from "./precaseCom.vue?vue&type=template&id=d5985382&scoped=true"
import script from "./precaseCom.vue?vue&type=script&lang=js"
export * from "./precaseCom.vue?vue&type=script&lang=js"
import style0 from "./precaseCom.vue?vue&type=style&index=0&id=d5985382&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5985382",
  null
  
)

export default component.exports